import { Grid, GridItem, Text } from '@chakra-ui/react';
import { footerItems } from './footerItems';
import { Link } from 'react-router-dom';
import { BaseCard } from '@cksoftware/react-base';

const Footer = () => {
  const getYear = () => {
    return new Date().getFullYear();
  };

  return (
    <BaseCard height={'auto'}>
      <Grid templateColumns='repeat(8, 1fr)' gap={1}>
        {footerItems.map((item, index) => (
          <GridItem key={index}>
            <Link to={item.to} style={{ color: 'black' }}>
              {item.text}
            </Link>
          </GridItem>
        ))}
      </Grid>
      <Text alignSelf='center' paddingTop={2}>
        Copyright ©{getYear()}. All rights reserved.
      </Text>
    </BaseCard>
  );
};

export default Footer;
